import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    conversation: { update_user_url: url, get },
  },
} = config

/**
 * Update user.
 *
 * @param {Object} user User to update
 */
const updateUser = (user) => axios.put(url, { user }, { headers: getHeaders(true) })

/**
 * Get user.
 *
 * @param {String} userId User to search
 */
const getUser = (userId) => axios.get(get.replace(':id', userId), { headers: getHeaders(true) })

export default { updateUser, getUser }
